/**
 * Created by Languagenut on 28/08/2019.
 */

import React  from 'react';
import Base from './activities_type.js';
import Translation from '../../../store/internationalization-store.js';
import {ProductStore , AccountStore} from '../../../store';
import AccountService from '../../../services/account-service.js'
import ProductService from '../../../services/product-service.js';

import Constants from '../../../constants.js'
import {Activity, ContentSelection } from './';
import Summary from './edit_comfirmation_step.js';
import SelectActivities from './edit_activities_type.js';
import Comfirmation from './edit_complete_comfirmation_step.js';
import UserStore from '../../../store/user-store.js';
import UserService from '../../../services/user-service.js';
import {Button , ProgressBar , Accordion , Card , Row , Col} from 'react-bootstrap'
import LanguageSelect from '../../language_select.js';

class AssignmentActivitiesType extends Base.component {

    constructor(props) {
        super();
    }

    triggerLanguageCall() {
        if (this.props.data.language == undefined) {
            return;
        } else {
            this.language = ProductStore.getCurriculumLanguage(this.props.data.language.ietf);
            this.languageArray = [this.language.ietf];
        }

        console.log(this.language)

        try
        {
            if (this.props.data == undefined) {
                this.props.data = {};
            }
            this.props.data.language = this.language;
        }
        catch(e)
        {

        }

        AccountService.getProductDetails(this.language.packageUid);
        AccountService.getCurriculumDetails(this.language.curriculumUid);
        ProductService.getAllAdditionalCurriculums();
    }

    componentWillMount() {

        ProductStore.on(Constants.GET_LANGUAGES ,  ()=>{
            this.triggerLanguageCall()
        });

        UserStore.on(Constants.GET_MY_ASSIGNMENTS, function() {
            var homeworks = UserStore.assignments;
            for(var key in homeworks) {
                if(!homeworks.hasOwnProperty(key)) continue;
                if(homeworks[key].id == this.props.information.homeworkID) {
                    this.props.data.language = {ietf:homeworks[key].languageCode};
                    this.triggerLanguageCall()
                }
            }
        }.bind(this));

        UserStore.on(Constants.GET_MY_ARCHIVED_ASSIGNMENTS, function() {
            var homeworks = UserStore.archived;
            for(var key in homeworks) {
                if(!homeworks.hasOwnProperty(key)) continue;
                if(homeworks[key].id == this.props.information.homeworkID) {
                    this.props.data.language = {ietf:homeworks[key].languageCode};
                    this.triggerLanguageCall()
                }
            }
        }.bind(this));


        AccountStore.on(Constants.GET_PRODUCT_FEATURES , ()=>{
            this.featuresList = AccountStore.getProductFeatures();
            this.setState({update:true, loaded:true})
        });

        AccountStore.on(Constants.GET_CURRICULUM_DATA , ()=>{
            this.setState({
                update:true
            })
        })

        ProductStore.on(Constants.GET_ADDITIONAL_CURRICULUM,  ()=>{
            var additionalCurriculums = ProductStore.getAdditionalCurriculums();
            var languages = [];
            var actualLanguges = [];
            var list = [];
            
            for(var i = 0 ; i < additionalCurriculums.length; i++) {
                if (languages.indexOf(additionalCurriculums[i].ietf) == -1 && additionalCurriculums[i].isSelected == "1") {
                    languages.push(additionalCurriculums[i].ietf);
                    actualLanguges.push({value:additionalCurriculums[i].ietf});
                }
                if (additionalCurriculums[i].isSelected == "1") {
                    list.push({value:String(additionalCurriculums[i].curriculumUid),
                        label:additionalCurriculums[i].name, 
                        ietf:additionalCurriculums[i].ietf, 
                        languageTitle:additionalCurriculums[i].languageName, 
                        isSelected:additionalCurriculums[i].isSelected == true,
                        information:additionalCurriculums[i].information,
                        startScreen:additionalCurriculums[i].startScreen})
                }
            }

            var languagesData = [];
            var data = this.state.totalCurriculumOptions;
            for (var i = 0; i < list.length; i++) {
                if (languagesData[list[i].ietf] == undefined) {
                    languagesData[list[i].ietf] = []
                }
                languagesData[list[i].ietf].push(list[i])
            }
            this.setState({
                totalCurriculumOptions:languagesData
            })
        });
    }

    componentDidMount() {
        if (this.props.data.language == undefined) {
            UserService.getAssignments();
            UserService.getArchivedAssignments();
        }
        ProductService.getAllLanguages(true);
    }

    modifyWizard(){

        var steps = [Summary , SelectActivities];
        if (window.location.hash.indexOf("editNew") > -1) {
            var steps = [SelectActivities];
        }
        var dataStuff = [];

        var isExam = false;
        var isVocab = false;
        var isSentence = false;
        var isGrammar = false;
        var isCustom = false;
        var isVerb = false;
        var isExtraVocab = false;
        var names = [Translation.get(2425 ,"Activities")]

        for (var i =0; i < this.featuresList.length; i++) {
            var features_uid = this.featuresList[i].features_uid;
            if (this.isChecked[features_uid]) {
                steps = steps.concat([ContentSelection, Activity]);
                switch(features_uid) {
                    case "custom":
                        isCustom = true;
                        break;
                    case "vocabs":
                        isVocab = true;
                        break;
                    case "sentences":
                        isSentence = true;
                        break;
                    case "grammar":
                        isGrammar = true;
                        break;
                    case "verbs":
                        isVerb = true;
                        break;
                    case "exam":
                        isExam = true;
                        break;
                    default:
                        isVocab = true;
                        break;
                }
            }
        }
        if (this.state.totalCurriculumOptions[this.language.ietf] != undefined) {
            for (var i =0; i < this.state.totalCurriculumOptions[this.language.ietf].length; i++) {
                if (this.isChecked["vocabs"+i]) {
                    steps = steps.concat([ContentSelection, Activity]);
                    isExtraVocab = true;
                }
            }
        }

        if (isCustom) {
            names = names.concat([Translation.get(649 ,"Select My Content"), Translation.get(2425 ,"Choose Activity")]);
            dataStuff.push("custom");
        }
        if (isVocab) {
            names = names.concat([Translation.get(2426 ,"Select Vocab"), Translation.get(2425 ,"Choose Activity")]);
            dataStuff.push("vocabs");
        }
        if (isExtraVocab) {
            if (this.state.totalCurriculumOptions[this.language.ietf] != undefined) {
                for (var i =0; i < this.state.totalCurriculumOptions[this.language.ietf].length; i++) {
                    if (this.isChecked["vocabs"+i]) {
                        names = names.concat([Translation.get(2426 ,"Select Vocab"), Translation.get(2425 ,"Choose Activity")]);
                        dataStuff.push("vocabs-"+this.state.totalCurriculumOptions[this.language.ietf][i].startScreen+"-"+this.state.totalCurriculumOptions[this.language.ietf][i].label);
                    }
                }
            }
        }
        if (isExam) {
            names = names.concat([Translation.get(2427 ,"Select Exam Skills"), Translation.get(2425 ,"Choose Activity")]);
            dataStuff.push("exam");
        }
        if (isSentence) {
            names = names.concat([Translation.get(2428 ,"Select Sentence"), Translation.get(2425 ,"Choose Activity")]);
            dataStuff.push("sentences");
        }
        if (isGrammar) {
            names = names.concat([Translation.get(2429 ,"Select Grammar"), Translation.get(2425 ,"Choose Activity")]);
            dataStuff.push("grammar");
        }
        if (isVerb) {
            names = names.concat([Translation.get(2430 ,"Select Verb"), Translation.get(2425 ,"Choose Activity")]);
            dataStuff.push("verbs");
        }
        
        steps = steps.concat([Comfirmation]);
        names = names.concat([Translation.get(1017 ,"Summary")]);
        this.props.data.types = dataStuff;
        this.props.data.counter = 0;
        this.props.onModify(steps, names)
    }

    setLanguageValue(language){

        this.language = language;
        //this.languageArray = [this.language.ietf];
        sessionStorage.setItem("packageUid", language.packageUid);
        try
        {
            if (this.props.data == undefined) {
                this.props.data = {};
            }
            this.props.data.language = language;
        }
        catch(e)
        {

        }


        this.setState({
            loaded:true
        })
        AccountService.getProductDetails(this.language.packageUid);
        AccountService.getCurriculumDetails(this.language.curriculumUid);
        ProductService.getAllAdditionalCurriculums();
    }

    render(){
        var isDisabled = true;
        for (var i =0; i < this.featuresList.length; i++) {
            var features_uid = this.featuresList[i].features_uid;
            if (this.isChecked[features_uid] != undefined && this.isChecked[features_uid] == true) {
                isDisabled = false;
            }
        }

        if (this.language != undefined && this.state.totalCurriculumOptions != undefined 
            && this.state.totalCurriculumOptions[this.language.ietf] != undefined) {
            for (var i =0; i < this.state.totalCurriculumOptions[this.language.ietf].length; i++) {
                if (this.isChecked["vocabs"+i]) {
                    isDisabled = false;
                }
            }
        }
        var AdvanceButton = React.createElement(Button, {
            onClick: this.props.forceAdvance,
            bsStyle:'primary',
            className:"btn-block",
            disabled:isDisabled
        },Translation.get(631 ,'Next'));

        let options = this.getTasks();
        let buttons = [];

        let vocabButtons = [];

        for(var i = 0; i < options.length; i++){
            if (options[i].isVocab == true) {
                if (options[i].title == "Vocabulary") {
                    if ([9201, 9202, 9203, 20634,20669,20704].indexOf(parseInt(AccountStore.curriculumData.startScreen)) > -1) {
                        options[i].title = "Cambridge IGCSE"
                    } else if ([13300,13301,13302].indexOf(parseInt(AccountStore.curriculumData.startScreen)) > -1) {
                        options[i].title = "Edexcel-International GCSE Vocabulary"
                    } else {
                        options[i].title = Translation.get(12709, "Vocab by Topic")
                    }
                }
                vocabButtons.push(this.renderButton(options[i]));
            } else {
                continue;
            }
        }

        if (vocabButtons.length > 1) {
            
            buttons.push(<Col style={{paddingBottom:"20px"}} md={12}><Accordion defaultActiveKey="none">
            <Card>
              <Card.Header>
                <Accordion.Toggle as={Button} variant="link" eventKey="0">
                  {Translation.get(12233, 'Vocabulary')}
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <Card.Body>
                    {vocabButtons}
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion></Col>);
          buttons.push(<br/>);
        }


        for(var i = 0; i < options.length; i++){
            if (options[i].isVocab == true) {
                continue;
            }
            buttons.push(this.renderButton(options[i]));
            buttons.push(<br/>)
        }

        if(!this.state.loaded) buttons = <ProgressBar animated now={45} animated />


        if(this.props.data)
            return <div>
                <Row>
                    <Col md={12}><LanguageSelect disabled={true} limitLanguages={this.languageArray} style={{fontWeight:700}} returnValue={this.setLanguageValue.bind(this)} 
                            title={<b>{Translation.get(12710 , 'Select Assignment Language')}</b>}/></Col>
                </Row>
                <Row style={{paddingBottom:'10px'}}>
                    <Col md={12}><b style={{paddingBottom:'5px'}}>{Translation.get(12711 , 'Select Assignment Components')}</b></Col>
                </Row>
                <Row>
                    {buttons}
                </Row>
                <Row>
                    <Col sm={6}></Col>
                    <Col sm={6}>{AdvanceButton}</Col>
                </Row>

            </div>;


    }
}


export default {
    name: function() {return Translation.get(12712 , 'Build Assignment')},
    icon:<i class="fa-2x fas fa-upload"></i>,
    title:null,
    disableButtons:true,
    onSubmit: function (done){
        done();
    }.bind(this),
    onBack:function(done){
        done();
    },
    component: AssignmentActivitiesType
}